import { render, staticRenderFns } from "./HotelName.vue?vue&type=template&id=9979b966&"
import script from "./HotelName.vue?vue&type=script&lang=js&"
export * from "./HotelName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports